import { FallbackRender } from '@sentry/react';
import { Alert } from 'antd';

export const errorBoundaryFallback: FallbackRender = ({
  error,
  componentStack,
  resetError,
}) => {
  return (
    <Alert
      message="An error occurred"
      description={(error as Error)?.toString()}
      type="error"
    />
  );
};
